/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { api } from '@/lib/api'
import type { PricingData } from './types'

// ----------------------------------------------------------------------------
// Pricing APIs
// ----------------------------------------------------------------------------

// Get model pricing data.
// skipErrorHandler: the public homepage marketplace calls this while logged out,
// where /api/pricing (HeaderNavModuleAuth "pricing") may return 401. Suppress the
// global "Session expired" toast + auth.reset so the homepage stays public and
// silently falls back to its built-in showcase. The /pricing & /models pages have
// their own auth guards + loading/empty states, so suppressing here is safe.
export async function getPricing(): Promise<PricingData> {
  const res = await api.get('/api/pricing', {
    skipErrorHandler: true,
  } as Record<string, unknown>)
  return res.data
}
